<div class="confirm-dialog">
  <h2 *ngIf="data.title" matDialogTitle>{{data.title}}</h2>
  <p [innerHTML]="data.message" [style.color]="data.type === 'autologout' ? 'mat.get-color-from-palette($ipeak-primary)' : 'black'"></p>
  <ng-container *ngIf="data.input">
    <mat-form-field><input [(ngModel)]="input" matInput/></mat-form-field>
  </ng-container>
  <mat-dialog-actions>
    <button (click)="dialogRef.close(input)" *ngIf="data.input" color="primary" mat-raised-button type="button">Ja</button>
    <button (click)="dialogRef.close(true)" *ngIf="!data.input" color="primary" mat-raised-button type="button">Ok</button>
    <button mat-button matDialogClose type="button">Abbrechen</button>
  </mat-dialog-actions>
</div>
